import { GET_VENDOR_LOGIN_REQUEST, GET_VENDOR_LOGIN_SUCCESS } from "./type";

const initialState = {
    loginUser: null,
    error: null,
    loading: false,
};

const VendorLoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_VENDOR_LOGIN_REQUEST:
            return {
                ...state,
                loginUser: null,
                loading: true,
                error: null,
            };
        case GET_VENDOR_LOGIN_SUCCESS:
            return {
                ...state,
                loginUser: action.payload,
                loading: false,
                error: null,
            };
        default:
            return state;
    }
};

export default VendorLoginReducer;
